import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
// App Components
import States from "../../../AppCore/Component/Geographic/States";
/** Utils */
import {PartnerAgreementValidator as validate, phoneMask, zipMask,} from "./agreementFormValidation";
/** Import Library */
import {CheckboxField, InputField,} from "../../../NTICore/component/Form/InputField";
import {AgreementDescription} from "./AgreementDescription";
import styles from "../../assets/css/page.css";
import {FooterPage} from "../../../AppCore/Component/Layout/FooterPage";

let AgreementComponent = ({
                            processingForm,
                            submitForm,
                            disabledSubmit,
                            partnerLegalName,
                            commissionRate,
                            handleSubmit,
                          }) => {
  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12 pull-left">
          <AgreementDescription commissionRate={commissionRate} partnerLegalName={partnerLegalName}/>
        </div>
      </div>

      <div className="row">
        {/* PARTNER INFORMATION */}
        <div className="col-lg-6 col-xs-12">
          <div className={`panel panel-default`}>
            <div className="panel-heading glnheading gln_lesspad">
              <p className="text-center glnh4">PARTNER INFORMATION</p>
            </div>
            <div className="panel-body gln_nopad no-padding-left">
              <div id="registration-form">
                <form className="form-horizontal">
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Company
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="legalName"
                              component={InputField}
                              label="Id"
                              placeholder="Company"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                            />
                            <i className="glyphicon glyphicon-briefcase"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Telephone
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="telephone"
                              component={InputField}
                              label="Id"
                              placeholder="Telephone"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                              type={"tel"}
                              {...phoneMask}
                            />
                            <i className="glyphicon glyphicon-phone"/>
                          </span>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Address
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="address1"
                              component={InputField}
                              label="Id"
                              placeholder="Address 1"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3"></div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="address2"
                              component={InputField}
                              label="Id"
                              placeholder="Address 2"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3 glhide">
                      <label className="col-sm-12 no-padding-right"/>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-6 gl_inputpushdown">
                          <span className="input-icon icon-right">
                            <Field
                              name="city"
                              component={InputField}
                              label="Id"
                              placeholder="City"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                      <div className="col-sm-6">
                          <span className="input-icon icon-right">
                            <Field name="stateWithCountry" component={States}/>
                            {/*<i className="glyphicon glyphicon-globe"/>*/}
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3 glhide">
                      <label className="col-sm-12 no-padding-right"/>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-6">
                          <span className="input-icon icon-right">
                            <Field
                              name="zip"
                              component={InputField}
                              label="Id"
                              placeholder="Zip"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                              {...zipMask}
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        First Name
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="firstName"
                              component={InputField}
                              label="Id"
                              placeholder="First Name"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                            />
                            <i className="glyphicon glyphicon-user"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Last Name
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="lastName"
                              component={InputField}
                              label="Id"
                              placeholder="Last Name"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                            />
                            <i className="glyphicon glyphicon-user"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Email
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="email"
                              component={InputField}
                              label="Id"
                              placeholder="Email"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                              disabled={true}
                            />
                            <i className="glyphicon glyphicon-envelope"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Title
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="title"
                              component={InputField}
                              label="Id"
                              placeholder="Title"
                              customClass="form-control input-sm"
                              autoComplete={"disabled"}
                            />
                            <i className="glyphicon glyphicon-briefcase"/>
                          </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* GREENLINK NETWORKS */}
        <div className="col-lg-6 col-xs-12">
          <div className={`panel panel-default`}>
            <div className="panel-heading glnheading gln_lesspad">
              <p className="text-center glnh4">GREENLINK NETWORKS</p>
            </div>
            <div className="panel-body gln_nopad no-padding-left">
              <div id="registration-form">
                <form className="form-horizontal">
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Company
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="legalName2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="GreenLink Networks"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-briefcase"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Telephone
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="Telephone2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="(888) 972-8802"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-phone"/>
                          </span>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Address
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="Address12"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="122 W John Carpenter Fwy #540"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3 glhide">
                      <label className="col-sm-12 no-padding-right"/>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-6 gl_inputpushdown">
                          <span className="input-icon icon-right">
                            <Field
                              name="City2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="Irving"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                      <div className="col-sm-6">
                          <span className="input-icon icon-right">
                            <Field
                              name="State2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="TX"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3 glhide">
                      <label className="col-sm-12 no-padding-right"/>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-6">
                          <span className="input-icon icon-right">
                            <Field
                              name="Zip2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="75039"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-globe"/>
                          </span>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        First Name
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="FirstName2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="Jhovanny"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-user"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Last Name
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="LastName2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="Rodriguez"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-user"/>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-3 col-md-2 col-lg-3">
                      <label className="col-sm-12 no-padding-right">
                        Title
                      </label>
                    </div>
                    <div className="col-sm-9 col-md-10 col-lg-9">
                      <div className="col-sm-12">
                          <span className="input-icon icon-right">
                            <Field
                              name="Title2"
                              component={InputField}
                              customClass="form-control input-sm"
                              placeholder="Vice President / Co-Founder"
                              disabled="disabled"
                            />
                            <i className="glyphicon glyphicon-briefcase"/>
                          </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-sm-12 col-xs-12 text-center">
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field name="agree" component={CheckboxField}/>
              </label>
              <span className={styles.termsAndConditionsText}>
                            Click here to indicate that you have read and agree to the terms presented in the{" "}
                <a
                  href="https://www.greenlinknetworks.com/partner/partner-legal"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                              Terms and Conditions
                            </a>{" "}
                agreement and the {" "}
                <a
                  href="https://www.greenlinknetworks.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                              Privacy Policy
                            </a>
                          </span>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{marginBottom: '100px'}}>
        <div className="col-lg-12 col-sm-12 col-xs-12 text-center">
          <button
            className="btn btn-success"
            onClick={handleSubmit(submitForm)}
            disabled={disabledSubmit}
          >
            Next Page
          </button>

          <div className="loader-div" style={{marginTop: '10px'}}>
            <ClipLoader size={35} color={"#193a63"} loading={processingForm}/>
          </div>
        </div>
      </div>

      <div className={`row ${styles.footer}`}>
        <div className={"col-sm-12"}>
          <FooterPage/>
        </div>
      </div>
    </Fragment>
  );
};

/** Allowed Props */
AgreementComponent.propTypes = {
  submitForm: PropTypes.func.isRequired,
};

/** Specifies the default values for props: */
AgreementComponent.defaultProps = {
  partnerLegalName: "",
  errorMessage: "",
};

AgreementComponent = reduxForm({
  form: "partnerAgreementForm",
  // Obtain the ability to reset the initial values
  // Has conflict with update related models
  enableReinitialize: true,
  validate, // <--- validation function given to redux-form
  //onSubmitSuccess: afterSubmit
})(AgreementComponent);

// You have to connect() to any reducers that you wish to connect to yourself
AgreementComponent = connect((state) => ({
  initialValues: state.PartnerAgreementReducer.partnerAgreement, // pull initial values from delivery reducer
}))(AgreementComponent);

export default AgreementComponent;



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/Agreement/Agreement.js